import {vec2, vec3} from 'gl-matrix';
import {assert, range} from './utils';

const {abs} = Math;

export const cubeFilenames = ['cyc+X', 'cyc-X', 'cyc+Y', 'cyc-Y', 'cyc-Z', 'cyc+Z'];
export const cubeFaceNames = ['Right', 'Left', 'Top', 'Bottom', 'Back', 'Front'];
export const cubeFaceNormals = [[1, 0, 0], [-1, 0, 0], [0, 1, 0], [0, -1, 0], [0, 0, 1], [0, 0, -1]];
export const cubeColors = range(6).map(c => { ++c; return vec3.fromValues(c & 1, (c >> 1) & 1, (c >> 2) & 1) });

export function getCubeFace(dir) {
    const ax = abs(dir[0]);
    const ay = abs(dir[1]);
    const az = abs(dir[2]);
    if (ax > az) {
        if (ax > ay)
            return dir[0] < 0 ? 1 : 0;
        else
            return dir[1] < 0 ? 3 : 2;
    } else {
        if (az > ay)
            return dir[2] < 0 ? 5 : 4;
        else
            return dir[1] < 0 ? 3 : 2;
    }
}

export function getCubeUV(out, dir, face) {
    const [dx, dy, dz] = dir;
    switch (face) {
        case 0: vec2.set(out, -dz/dx, -dy/dx); break;
        case 1: vec2.set(out, -dz/dx,  dy/dx); break;
        case 2: vec2.set(out,  dx/dy,  dz/dy); break;
        case 3: vec2.set(out, -dx/dy,  dz/dy); break;
        case 4: vec2.set(out,  dx/dz, -dy/dz); break;
        case 5: vec2.set(out,  dx/dz,  dy/dz); break;
    }
    out[0] = (1 + out[0]) / 2;
    out[1] = (1 + out[1]) / 2;
    return out;
}

export function getCubeDirection(out, face, u, v) {
    const x = 2 * u - 1;
    const y = 2 * v - 1;
    switch (face) {
        // X
        case 0: vec3.set(out, +1, -y, -x); break;
        case 1: vec3.set(out, -1, -y,  x); break;
        // Y
        case 2: vec3.set(out, x, +1, y); break;
        case 3: vec3.set(out, x, -1, -y); break;
        // Z
        case 4: vec3.set(out, x, -y, +1); break;
        case 5: vec3.set(out, -x, -y, -1); break;
    }
    return vec3.normalize(out, out);
}

export class Cube {
    gl = null;
    size = 0;
    texture = null;
    framebuffers = null;

    constructor(gl, size) {
        this.gl = gl;
        this.size = size;
        this.createTexture();
        this.createFramebuffers();
    }

    createTexture() {
        const {gl, size} = this;
        this.texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_CUBE_MAP, this.texture);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        for (let face = 0; face < 6; ++face) {
            const target = gl.TEXTURE_CUBE_MAP_POSITIVE_X + face;
            gl.texImage2D(target, 0, gl.RGBA, size, size, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
        }
    }

    createFramebuffers() {
        const {gl} = this;
        this.framebuffers = [];
        for (let face = 0; face < 6; ++face) {
            const target = gl.TEXTURE_CUBE_MAP_POSITIVE_X + face;
            const framebuffer = gl.createFramebuffer();
            gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
            gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, target, this.texture, 0);
            const status = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
            assert(status === gl.FRAMEBUFFER_COMPLETE);
            this.framebuffers.push(framebuffer);
        }
    }
}
